import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { GetMonthlyActiveUserCountPayloadType } from "../../../../commonTypes/listing";
import MonthlyActiveUserCountTable from "../../../../components/AdminReports/UserLoginSessionReport/MonthlyActiveUserCountTable";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  TableHeader,
  TableLoader,
} from "../../../../components/commons";
import { MONTHLY_ACTIVE_USER_COUNT_HEADERS } from "../../../../constant/tableHeadersConstants/userLoginSessionReportsHeaderConst";
import { resetSession } from "../../../../redux/auth";
import {
  getMonthlyActiveUserReportAction,
  resetListingError,
  resetListingSuccess,
  resetMonthlyActiveUserList,
} from "../../../../redux/listing";
import { MonthlyActiveUserCountType } from "../../../../redux/listing/listingTypes";
import { RootState } from "../../../../redux/rootReducers";
import { getLastFiveFinancialYears } from "../../../../utils/commonFunctions";

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
type AppProps = {
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  monthlyActiveUserList: [] | MonthlyActiveUserCountType[];
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchGetMonthlyActiveUserReportAction: (
    data: GetMonthlyActiveUserCountPayloadType
  ) => void;
  dispatchResetMonthlyActiveUserList: () => void;
  dispatchResetSession: () => void;
};
const MonthlyActiveUser = ({
  token,
  fetching,
  error,
  success,
  statusCode,
  monthlyActiveUserList,
  dispatchResetListingError,
  dispatchResetListingSuccess,
  dispatchGetMonthlyActiveUserReportAction,
  dispatchResetMonthlyActiveUserList,
  dispatchResetSession,
}: AppProps) => {
  const [financialYear, setFinancialYear] = useState({
    value: "",
    label: "Select..",
  });
  const [displayedFinancialYear, setDisplayedFinancialYear] = useState({
    value: "",
    label: "Select..",
  });
  useEffect(() => {
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetMonthlyActiveUserList();
  }, []);

  const handleFinancialChange = (data: any) => {
    setFinancialYear({
      value: data?.value,
      label: data?.label,
    });
  };
  const handleSubmitData = () => {
    setDisplayedFinancialYear(financialYear);
    let finalData: GetMonthlyActiveUserCountPayloadType = {
      token,
      financial_year: financialYear?.value,
    };

    dispatchGetMonthlyActiveUserReportAction(finalData);
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingError();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="Monthly Active User" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div
            style={{ display: "flex", paddingTop: "25px", paddingLeft: "23px" }}
          >
            <div className="col-md-3">
              <label className="mb-1" htmlFor="">
                Financial Year
              </label>
              <Select
                options={getLastFiveFinancialYears()}
                value={financialYear}
                onChange={handleFinancialChange}
              />
            </div>
            <div className="col-md-3" style={{ marginTop: "28px" }}>
              <button
                className="btn btn-primary"
                onClick={handleSubmitData}
                disabled={!financialYear?.value}
              >
                Get Data
              </button>
            </div>
          </div>
          {/*  */}
          <hr className="mt-4 mb-4" />
          {monthlyActiveUserList &&
          monthlyActiveUserList?.length === 0 &&
          !fetching ? (
            <EmptyListPage
              title="No Data Found!"
              text="Choose financial year to get monthly active user report."
              imageWidth="30%"
            />
          ) : (
            <>
              <h5 className="text-center"> Monthly Active User Count</h5>
              <div className="d-flex justify-content-center mt-3">
                <h6 className="text-center mr-4">
                  Financial Year:{" "}
                  <span className="font-weight-bolder">
                    {displayedFinancialYear?.value}
                  </span>
                </h6>
              </div>
              {fetching ? (
                <TableLoader Rows={10} ColumnPerRow={4} />
              ) : (
                <div className="jobsType">
                  <table className="table thead-light table-bordered">
                    <thead className="text-left sticky-table-header-without-zindex">
                      <TableHeader
                        tableHeader={MONTHLY_ACTIVE_USER_COUNT_HEADERS}
                      />
                    </thead>
                    <tbody>
                      <MonthlyActiveUserCountTable
                        data={monthlyActiveUserList}
                        tableHeaders={MONTHLY_ACTIVE_USER_COUNT_HEADERS}
                      />
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  success: state.listing.success,
  fetching: state.listing.fetching,
  token: state.auth.token,
  error: state.listing.error,
  statusCode: state.listing.statusCode,
  monthlyActiveUserList: state.listing.monthlyActiveUserList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetListingSuccess: () => dispatch(resetListingSuccess()),
  dispatchResetListingError: () => dispatch(resetListingError()),
  dispatchGetMonthlyActiveUserReportAction: (
    data: GetMonthlyActiveUserCountPayloadType
  ) => dispatch(getMonthlyActiveUserReportAction(data)),
  dispatchResetMonthlyActiveUserList: () =>
    dispatch(resetMonthlyActiveUserList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyActiveUser);
